var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSnl = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 80 80" }, props, { children: _jsx("path", { fill: "currentColor", d: "M60.216 35.649C60.216 24.244 50.99 15 39.61 15S19 24.244 19 35.649c0 8.334 4.928 15.513 12.025 18.775h17.167c7.096-3.262 12.024-10.443 12.024-18.775M52.688 56.845h-26.16v6.29h26.16zM50.072 63.689H29.144V65h20.928zM50.072 56.29H29.144l1.465-1.311h18z" }) }))); };
export default SvgSnl;
